import ActionTypes from "../../../../constants/ActionTypes";
import { ICampaignModeState } from "./types";

const initialState: ICampaignModeState = {
  status: false,
  oreSubmitData: null,
  tpIds: [],
  recommendedTpId: 0
};

const campaignModeReducer = (
  state = initialState,
  action: any,
): any => {
  switch (action.type) {
  case ActionTypes.CAMPAIGN.CAMPAIGN_MODE.SET_CAMPAIGN_MODE_STATUS:
    return {
      ...state,
      status: action.payload
    };
  case ActionTypes.CAMPAIGN.CAMPAIGN_MODE.SET_CAMPAIGN_ORE_SUBMIT_DATA:
    return {
      ...state,
      oreSubmitData: {
        product: action.payload.product,
        oreOffer: action.payload.oreOffer,
        channel: action.payload.channel
      }
    };
  case ActionTypes.CAMPAIGN.CAMPAIGN_MODE.SET_CAMPAIGN_MODE_RECOMMENDED_TP_TMCODE:
    return {
      ...state,
      recommendedTpId: action.payload
    };
  case ActionTypes.CAMPAIGN.CAMPAIGN_MODE.SET_CAMPAIGN_MODE_AVAILABLE_TP_TMCODES:
    return {
      ...state,
      tpIds: action.payload
    };
  case ActionTypes.CAMPAIGN.CAMPAIGN_MODE.CLEAR_CAMPAIGN_MODE:
    return {
      ...state,
      status: false,
      oreSubmitData: null,
      tpIds: [],
      recommendedTpId: 0
    };
  }
  return state;
};

export default campaignModeReducer;

